import { render, staticRenderFns } from "./SnackbarDiscount.vue?vue&type=template&id=21db1cff&scoped=true"
import script from "./SnackbarDiscount.vue?vue&type=script&lang=js"
export * from "./SnackbarDiscount.vue?vue&type=script&lang=js"
import style0 from "./SnackbarDiscount.vue?vue&type=style&index=0&id=21db1cff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21db1cff",
  null
  
)

export default component.exports